import { DynamicPdfImage, GenericPdfImage, LongDeclarationImage, NoDataImage, RasPolyPackImage, GstSummaryWithoutSku, BatchSummaryPdfImage, PurchaseOrderPdfImage, DynamicPrimaryIcon } from "../../../../assets/images"

export const handlePdfImages = (name: string) => {
    switch (name) {
        case "Ras Polypack": return RasPolyPackImage
        case "Generic Pdf": return GenericPdfImage
        case "Dynamic Pdf": return DynamicPdfImage
        case "Ras Polypack": return RasPolyPackImage
        case "Long Declaration": return LongDeclarationImage
        case "GST Summary Without SKU": return GstSummaryWithoutSku
        case "Batch Summary": return BatchSummaryPdfImage
        case "Standard": return PurchaseOrderPdfImage
        case "Dynamic Primary": return DynamicPrimaryIcon
        default: return NoDataImage
    }
}